export default {
    common:{
		// 666 新加 新加部分在其他语言配置文件里没有翻译
		askedQuestions:'常見問題',
		showMore:'顯示更多',
		nofind:'找不到想補科目',
		helpFind:'可以在這裏幫你',
		searchNow:'立即尋找',
		formalClass:'正式課 50分鐘',
		reportType:'類型',
		reportDate:'報告日期',
		classReport:'課堂報告',
		progressReport:'進度報告',
		reportDetails:'詳情',
		remainingClasses:'剩餘課堂',
		unbookedClassroom:'課堂總數',
		memberClassReport:'{name}的課堂報告',
		memberprogressReport:'{name}的進度報告',
		back:'返回',
		whatHelp:'有何需要協助？',
		generalQuestion:'一般問題',
		leave:'離開',
		aboutToBegin:'即將開始課堂',
		surplus:'剩餘',
		teacherIntroduction:'老師簡介',
		personalPhoto:'個人照片',
		introductionFilm:'簡介影片',
		teachingAchievements:'教學成果',
		startTeaching:'申請開教',
		phontHint:'選一張有活力的頭像，給學生和家長第一個好印象',
		photoDemonstration:'頭像照片示範',
		personalPhoto1:'你的照片必需符合以下要求:',
		personalPhoto2:'望著鏡頭和微笑',
		personalPhoto3:'主要拍攝頭部至肩膀位置',
		personalPhoto4:'拍攝主體置中，不能過近或遠',
		personalPhoto5:'不能帶動作、物件和包含其他人',
		personalPhoto6:'燈光和背景需柔和自然',
		personalPhoto7:'不能帶任何字句和標語',
		personalPhoto8:'不能遮擋臉部和眼睛(除特別需要)',
		personalPhoto9:'本人清楚及明白上述照片要求，並同意照片將展示在本平台上',
		foldUp:'收起',
		completeRegistration:'確定完成注冊嗎',
		iConfirm:'待我確認預約',
		teacherConfirm:'待老師確認預約',
		indispute:'爭議中',
		noContent:'暫無',
		confirmPayment:'確認支付嗎',
		afterReading:"請閲讀完上方協議",
		agreeAgreement:"請閲讀並確認同意協議",
		teatClasstime:"1堂25分鐘課",
		confirmSubmit:"確定要提交嗎",
		cancelSubmitText:"提交這份報告",
		toComplete:"去完成",
		teacherCompleted:"已完成",
		dayContent:"天",
		progressReportHint:"爲了不影響上課進度，請查看課包剩餘次數，以免老師的熱門時段被搶購。",
		patternStudent:"學生模式",
		patternTeacher:"老師模式",
		homePage:"主頁",
		myWalletuser:'我的錢包',
		transactionRecords:"交易記錄",
		logoutUser:"登出",
		
		
		
		webName:'MiraStudent',
		login:'登入',
		startImmediately:'立即開始',
		delete:'刪除',
		experienceClass:'試堂',
		enter:'請輸入',
		cancel:'取消',
		confirm:'確認',
		select:'請選擇',
		operationSuccessful:'操作成功',
		upload:'上傳',
		classID:'課堂ID',
		wantToDelete:'确定要刪除吗？',
		studyReport:'學習報告',
		submit: '提交',
		userCenter:'個人中心',
		setting:'設置',
		updataSuccess:'提交成功，请等待审核',
		balance:'幫餘額',
		simplifiedChinese: '簡體中文',
		traditionalChinese: '繁體中文',
		English: '英語',
		Japanese: '日語',
		Korean: '韓語',
		courseCancelled: '課程已取消',
		contactTeacher:'聯係老師',
		numberClass:'{num}堂課',
		endTime:'到期時間',
		setSuccess:'設定成功',
		studentsUpload:'學生上傳',
		teacherUpload:'老師上傳',
		hour:'小時',
		class:'堂',
		fivetyminutes:'50分鐘'
	},
	headers:{
		searchTeachers:'搜索教師',
		recommendTeachers:'推介老師',
		becomeTeacher:'成爲老師',
		teacherPortal:'老師入口',
		balance:'MIRA幫餘額'
	},
	footers:{
		// 666新加字段
		primarySchool:'初小課程',
		ascoretest:'呈分試',
		dse:'DSE',
		juniorHighSchool:'初中',
		ib:'IB',
		alevel:'A Level',
		igcse:'iGCSE',
		Astudent:'我是學生',
		ATeacher:'我是老師',
		trialDiscounts:'試堂優惠',
		serviceGuarantee:'服務保障',
		recommendedTeacherProgram:'推薦老師計劃',
		termsofService:'服務條款',
		termsofUse:'使用條款',
		privacyPolicy:'私隱條款',
		cookie:'Cookie政策',
		teacherServiceAgreement:'老師服務協議',
		modal1:'推薦新老師獎賞計劃',
		modal2:'推薦獎賞',
		modal3:'於本計劃下，現有老師每成功推薦一位新老師，並獲批開立老師帳戶，而新老師於開始教學起計的3個月內，所完成日的教學時數，將加到推薦老師的累積課時，用作計算導級數及平台佣金比率。',
		modal4:'參加方法',
		modal5:'被推薦的老師需要在填寫「成為老師」申請表時，輸入推薦老師的申請編號(於新老師遞交申請後獲得)',
		modal6:'優惠條款及細則：',
		modal7:'每位被推薦老師只限填寫一位推薦人',
		modal8:'推薦老師人數無上限，成功推薦越多，獎賞越多',
		modal9:'如對獎賞計算方法有何爭議，本平台有權作最終決定',
		
		
		
		
		
		about:'關於',
		pavilionToUs:'閣於我們',
		used:'如何使用',
		becomeTeacher:'成為老師',
		naturalResources:'资源',
		study:'學習專欄',
		help:'幫助',
		contactUs:'聯絡我們',
		questions:'常見問题',
		pay:'付款方式',
		refund:'退款政策',
		socialize:'MiraStudent 社交'
	},
	mainIndex:{
		// 666新加的字段
		howUsed:'如何使用？',
		reasonTitle5:'最新科技 真實體驗',
		reasonContent5:'AI配對 視訊及筆記軟件 高效體驗',
		reasonTitle7:'課堂報告和跟進',
		reasonContent7:'課堂報告，緊貼學生進度',
		reasonTitle6:'管理老師 更換老師保證',
		reasonContent6:'自由試堂，隨時更換老師',
		reasonTitle8:'交易安全  避免網騙 ',
		reasonContent8:'課後放款給老師，防止失蹤欺詐',
		processOne_4:'點選「立即開始」，使用篩選欄，按你的要求，篩選老師',
		processOne_5:'點選主頁中，你想補的科目，會顯示該專科老師',
		processTwo_4:'老師確認預約後，安裝你想用的視訊工具：Zoom 或 VooV',
		processThree_3:'試堂後，可按需要或老師的建議購買正式課堂',
		
		
		
		// 重新翻譯
		reasonForSelection:'爲什麽要選擇MiraStudent？',
		reasonTitleOne:'嚴選老師  專科專教',
		reasonContentOne:'嚴選老師，有註冊教師，優質教學',
		reasonTitleTwo:'節省時間  減輕壓力',
		reasonContentTwo:'在家網上學習，省時學習',
		reasonTitlethree:'個人化專屬互動學習',
		reasonContentThree:'一對一專屬學習  高效互動專注',
		reasonTitlefour:'收費公道合理',
		reasonContentFour:'老師自由訂價，學生按預算選購',
		classProcess:'只需3步與你的專屬老師上課',
		processOne_1:'選擇老師',
		processOne_2:'挑選老師有3個方法：',
		processOne_3:'使用「搜索老師」，回答幾條問題，快速匹配合適老師',
		processTwo_1:'購買及預約試堂',
		processTwo_2:'選好老師後，點選購買你想補的科目試堂',
		processTwo_3:'在你的賬戶中，預約該老師開放的上堂時段',
		processThree_1:'開始上堂',
		processThree_2:'到預約時間，在「我的課堂」，點選有關課堂，便可跟你的專屬老師開始學習',
		
		
		
		
		titleOne:'1對1 專業老師',
		titleTwo:'個性化教學·互動專注學習',
		titleThree:'網上補習平台',
		titleFour:'MiraStudent 是一個網上的補習平台，以教育科技打破地域和時間界限，讓學生安在家中',
		titleFive:'都能獲得專業教師的指導，節省時間，提升學習效率和能力，鬆付考試!',
		titleSubject:'熱門補習科目',
		viewMore:'瀏覽更多',
		invitationalEducation:'尋找能啟發你學習潛能的老師',
		introduce:'我們有註冊教師、專科老師、語言專家、社會專業人士，助你解決不同學習需求',
		
		
		
		
		obtainIncome:'透過與學生分享你的專業知識以赚取收入',
		onlineTeaching:'註册以開始使用 MiraStudent 網上授課',
		evaluate:'聽聽MiraStudent學生的評價'
	},
	cashDesk:{
		// 666 新的
		orderOverview:'訂單概覽',
		degree:'程度',
		money:'金額',
		coupon:'優惠券',
		enjoyProtection:'你可享有以下保障',
		
		
		cashRegister:'收銀台',
		goods:'商品',
		subject:'科目',
		category:'類別',
		time:'時間',
		classNum:'堂數',
		total:'小計',
		single:'單堂',
		discount:'優惠',
		selectCoupon:'選擇優惠券',
		noCoupon: '暫不選擇',
		couponDiscount:'購買試堂抵扣',
		totalCount:'總價',
		paymentMethod:'支付方式',
		payment:'使用MT幣',
		balance:'餘額',
		noBalance:'餘額不足，點擊充值',
		pay:'確認並支付',
		purchaseSuccessful:'购买成功'
	},
	forStudy:{
		// 重新翻译 666
		studyFor:'你想學甚麼課程？',
		motherTongue:'想要的教學語言？',
		mentorLevel:'老師專長?',
		
		// 新加的
		whatExtent:'你是甚麼程度？',
		whatClass:'你想補甚麼科目？',
		schoolClass1:'香港小學課程',
		schoolClass2:'香港中學課程',
		schoolClass3:'國際公開試課程',
		
		
		
		skipQuestion:'跳過問題',
		chooseMentor:'自行挑選老師',
		budget:'每堂課預算多少 ?',
		country:'你的國家/地區 ?',
		classTime:'上課時間',
		
		
		masterLanguage:'同時掌握的語言?',
		weekMon_weekFri:'周一~周五',
		weekend:'周六、周日',
		anyTime:'任何時間'
		
	},
	forClassIndex:{
		// 重新翻译
		onlineTeacher:'你的Mira老師',
		
		
		// 666新加
		noResult:'未找到相關結果，建議調整篩選條件',
		recommendOtherTeachers:'你或可能喜歡以下推薦老師',
		pricePerSession:'每堂價格',
		languageInstruction:'授課語言',
		classDay:'上課日子',
		expertise:'專長',
		any:'任何',
		mandarin:'普通話',
		english:'英語',
		cantonese:'廣東話',
		
		
		
		languageLevel: '語言級別',
		
		seacher:'搜尋老師姓名或關鍵字',
		class:'課程',
		pleaseSelect:'請選擇',
		budget:'每堂學習預算',
		country:'来自國家/地區',
		classTime:'上課時間',
		schedulingPeriod:'排课时段',
		mentorLevel:'老師級別',
		brfore:'以前',
		motherTongue:'母語者',
		masterLanguage:'同時掌握的語言',
		suitable:'位適合你需求的老師',
		new:'NEW',
		highQualityMentor:'次優質老師',
		seniorTutor:'資深老師',
		professionalTeacher:'專業老師',
		professor:'教授',
		speek:'會説',
		learnMore:'了解詳情',
		minute:'分鐘',
		poetryHall:'試堂',
		trialClass:'預約試聼課',
		contactMentor:'聯絡老師',
		viewClass:'查看完整課堂安排表'
	},
	personalizationTeacher:{
		seacherTeacher:'尋找你的個性化老師',
		hint:'花1分鐘回答幾條簡單問題，以助匹配最適合你的老師',
		studyFor:'你學習的目的是？',
		start:'開始',
		selectTeacher:'自行挑選老師'
	},
	teacherVue:{
		// 666 新加
		achievementSharing:'教學成果分享',
		outstanding:'傑出',
		excellent:'優秀',
		veryGood:'很好',
		good:'良好',
		studentEvaluation:'則學生評價',
		halfPrice:'半價試堂',
		bookImmediately:'立即預約試堂',
		favoriteMentor:'收藏導師',
		savedFavorites:'已收藏',
		contactMentor:'聯絡導師',
		freeProgram:'免費試堂計劃',
		providedTeacher:'老師提供，已存檔',
		pQCertificate:'專業資格證書',
		teacherCenter1:'現有學生',
		teacherCenter2:'新學生',
		teacherCenter3:'已預約課堂',
		teacherCenter4:'未預約課堂',
		teacherCenter5:'暫停招生',
		teacherCenter6:'继续招生',
		
		
		// 重
		evaluate:'學生評價',
		
		
		
		information:'開於{name}的资讯',
		teachingSubjects:'教學科目',
		professorlevel:'教授級別',
		highestEducationLevel:'最高學歷',
		experience:'特殊教育需要經驗',
		aboutMe:'關於我',
		videoIntroduction:'影片介紹',
		cannotPlay:'不支持視頻播放',
		classTime:'授課時間',
		resume:'履歷',
		
		myClass:'我的課堂',
		testClassTime:'1堂25分鐘課',
		formalClasses:'正式堂',
		formalClassTime:'{number}堂50分鐘課',
		priceAdjustment:'老師課堂價格將在{time}調價'
	},
	login:{
		//666 重新翻译
		hint:'以下方式繼續登錄或註冊賬戶，説明你已閲讀並同意 MiraStudent的',
		
		
		// 新的
		and:'和',
		privacyPolicy:'私隱協議',
		haveAccount:'已有賬戶？',
		passwordHint:'密碼最少8個字符，及最少1個大寫字母、1個小寫字母和1個數字',
		errorHint:'密碼格式錯誤',
		registeredSuccessfully:'註冊成功',
		editSuccessfully:'修改成功',
		currentPassword:'目前密碼',
		newPassword:'新密碼',
		confirmNewPassword:'確認新密碼(輸入多一次)',
		resetPassword:'重置密碼',
		becomeMemberNow:'立即成為會員',
		nameHint:'最多15字',
		mainContent1:'學校類別',
		mainContent2:'就讀的課程',
		mainContent3:'想補的科目(可多選)',
		mainContent4:'學習目標',
		mainContent5:'就讀的學校',
		mainContent6:'年級',
		mainContent7:'考卷語言(非語文科)',
		mainContent8:'授課語言要求',
		mainContent9:'完成註冊',
		mainContent10:'最高教育程度',
		mainContent11:'教授級別(可多選)',
		mainContent12:'特殊教育經驗',
		mainContent13:'會說語言可多選',
		mainContent14:'教授科目(可多選)(最多10個)',
		
		
		
		
		login:'登錄',
		welcome:'歡迎來到MiraStudent !',
		loginMethod:'使用{way}登入',
		or:'或者',
		email:'電子郵箱',
		emailAccount:'你的電子郵件地址',
		password:'密碼',
		passwordPlaceholder:'請輸入密碼',
		forgotPassword:'忘記密碼',
		rememberMe:'記住我',
		toLogin:'登入',
		noAccount:'還未有賬戶 ？',
		register:'註冊',
		editPassword:'修改密碼',
		retry:'{countdown}秒後重試',
		send:'發送驗證碼',
		code:'驗證碼',
		codePlaceholder:'請輸入驗證碼'
		
	},
	studentsCom:{
		// 666 重新翻譯
		reportCourseNotCompleted:'報告課堂未完成',
		situationDescription:'很抱歉你的課堂沒有按預期完成，請在下面填寫有關情況：',
		explanationContent:'如果你有任何證據支持有關問題，請在此提交，以達最佳結果',
		teacherName: '老師名稱',
		orderNumber: '訂單編號',
		
		
		//新的 
		reason1:'計劃改變',
		reason2:'老師缺席',
		reason3:'老師遲到',
		reason4:'課堂內容或教學問題',
		reason5:'與老師協商退款',
		reason6:'其他',
		overview:'概覽',
		confirmationCompletion:'待確認完成',
		all:'全部',
		sortBy:'排序方式',
		searchKey:'搜索關鍵字',
		classDate:'上課日期',
		keyLesson:'本課重點',
		researchTopic:'課題',
		keyLearningPoints:'學習重點',
		studentPerformance:'學生表現',
		teacherMessage:'老師留言',
		classroomHighlights:'課堂亮點',
		studySuggestions:'學習建議',
		nextPreview:'下堂預告',
		overallEvaluation:'總評',
		workOrTest:'作業或測驗',
		supportYou:'我們Support你',
		courseContent:'課程內容和目標',
		keyCourse:'課程重點',
		learningObjectives:'學習目標',
		classroomPerformance:'課堂表現',
		performance:'表現',
		rating:'評分',
		cPerformance1:'專注力',
		cPerformance2:'掌握度',
		cPerformance3:'參與度',
		cPerformance4:'進步幅度',
		cPerformance5:'作業/測驗',
		examPerformance:'應試表現',
		testtaking:'應試技巧',
		collectedTeachers:'收藏的老師',
		pastTeachers:'過往的老師',
		searchOrderID:'請輸入要搜索的訂單ID',
		sortDescOrEsc1:'創建時間 倒序',
		sortDescOrEsc2:'創建時間 正序',
		sortDescOrEsc3:'修改時間 倒序',
		sortDescOrEsc4:'修改時間 正序',
		purchaseCourse:'購課',
		warmReminder:"溫馨小提示",
		
		
		
		
		calendar:'行事曆',
		month:'月',
		week:'周',
		whyNotCompleted:'*為什麼你的課堂未完成?',
		solution:'*你的预期解决方案是什麼?',
		explanation:'解釋和證明',
		uploadImage:'上傳最多5張圈片或影片作為證明',
		
		// 我的課堂
		myClass:'我的課堂',
		bookNewClassroom:'預約新課堂',
		list:'列表',
		waitingClass:'待上课',
		completed:'已完成',
		pendingConfirmation:'待確認課程',
		enterClassroom:'進入課堂',
		upcomingCourses:'即將到來的課程',
		waitingConfirm:'待老師確認',
		waitingConfirmstudent:'待學生確認',
		confirmAfterClass:'課後待確認',
		confirmed:'已確認',
		// calendar:'日曆',
		
		// 我的作業
		myWork:'我的作業',
		// 我的筆記
		myNotes:'我的筆記',
		// 我的老師
		myTeacher: '我的老師',
		reserve: '預約',
		chat: '對話',
		giveExtra: '加赠',
		recommendedTeacher: '推薦的老師',
		professionalTeacher: '專業老師',
		seniorTeacher: '資深老師',
		myTest:'我的測驗',
		
		
		resolved: '已解決',
		selectSolutionTip: '請選擇與學生商定後的解決方案，提交後由學生在48小時內進行確',
		selectSolution: '請選擇調解方案',
		selectPlaceholder: '請選擇',
		fillRefundAmount: '請填寫退款金額',
		feeDeductionTip: '該課的學費先扣退款金額，在扣佣金，剩除部分打入老師錢包',
		
		
		teacherEvaluation: '老師評價',
		classSatisfaction: '課堂滿意度',
		selectTeachingTraits: '選擇適合老師{name}的教學特質標籤',
		showOnProfileNamed: '此回復將展示在老師的個人頁面(記名)',
		showOnProfileAnonymous: '此回復將展示在老師的個人頁面(匿名)',
		writeClassExperience: '寫下你的上課體驗心得',
		classFeedback:'給與老師{name}的課堂回饋',
		
		
		tradingOrder: '交易訂單',
		completedOrders: '已完成訂單',
		refundedOrders: '已退課訂單',
		transactionTime: '交易時間',
		
		// courseContent: '課程内容',
		amount: '金額',
		unresolved: '未解決',
		uploadDataDecision: '上傳證據由平台決定',
		explanationAndProof: '解釋和證明',
		uploadEvidenceTip: '如果你有任何證據支持你的請求，請盡可能多的提供，以得最佳結果',
		
		
	},
	userMySetting:{
		// 666 新的
		fillInformation:'請填寫以下資料，讓我們提供最貼心的服務 (*必填)',
		
		// 重新翻译
		name: '用戶名',
		birthday: '出生年份',
		displayLanguage: '授課語言',
		country: '所在國家/地區',
		contactPhone:'聯絡電話(WhatsApp)',
		userCode:'用戶編號',
		iam:'我是',
		studentsOrParents:'學生/家長',
		teacher:'老師',
		
		
		
		setting: '設定',
		logOut: '退出登錄',
		basicInfo: '基本資料',
		photo: '照片',
		uploadAvatarTip: '請按頭像上傳清晰的個人頭像',
		inputNamePlaceholder: '請輸入姓名',
		gender: '性別',
		selectPlaceholder: '請選擇',
		male: '男',
		female: '女',
		timeZone: '時區',
		currency: '貨幣',
		save: '儲存',
		accountVerification: '賬號驗證',
		email: '電子信箱',
		inputEmailPlaceholder: '請輸入',
		sendVerificationEmail: '發送驗證信',
		password: '密碼',
		editPassword: '修改密碼',
		bindApp: '綁定app',
		facebook: 'Facebook',
		google: 'Google',
		wechat: 'Wechat',
		clickToBind: '點擊綁定',
		unbind: '解綁',
		confirmLogout: '確定退出登錄嗎？',
		logoutContent: '退出登錄',
		confirm: '確定',
		cancel: '取消',
		
	},
	userMyWallet:{
		// 666 重新翻译
		approximateAmountTip: '*此金額可能因匯率變動而有所差別，僅供參考，所有金額均以港幣HK$為準。',
		classNumber: '課堂包',
		orderId: '訂單編號',
		
		// 新加
		teacherName:'老師名稱',
		
		
		myWallet: '我的錢包（學生）',
		recharge: '儲值',
		availableBalance: '可用結餘',
		walletTransactionDetails: '錢包交易詳情',
		time: '時間',
		item: '事項',
		amount: '金額',
		
		
	},
	userCenter:{
		// 666新加
		myClassPackage:'我的課堂包',
		good:'太好了 !',
		limitedPromotion:'限時推介',
		timeLimit:'時限',
		
		// 重新翻译
		myCourses: '我的課堂',
		validTime: '有效期至',
		
		
		greeting: 'Hello！',
		nickname: '暱稱',
		todolist:'形事厝',
		myCoursesPackage: '我的課程套餐',
		classBalance: '課堂餘額',
		appointment: '預約',
		viewClass: '查看課堂',
		myCoupons: '我的優惠券',
		newUserCoupon: '新用戶註冊10元優惠券',
		minimumConsumption: '最低消費門檻',
		myHomework: '我的作業',
		completedHomework: '份已完成作業',
		myTest: '我的測驗',
		noIncompleteTest: '沒有未完成的測驗',
		learningReport: '學習報告',
		personalizedRecommendation: '個人化推薦',
		todayHot: '本日熱門',
		fromUK: '來自英國',
		nativeLanguage: '母語',
		hourlyCharge: '每小時收費',
		ticketPackage: '套票方案',
		discount: '折扣',
		recommendationReason: '推薦理由',
		bookNow: '立即預約',
		toDoList: '待辦事項',
		timeLimitedOffer: '限時優惠',
		purchase: '購買',
		remainingTime: '剩餘時間',
		teacherAppointmentConfirm: '教師發送課時預約確認',
		timeZone: '時區',
		confirm: '確認',
		reject: '拒絕',
		reportContent:'份/最近3个月',
	},
	appointment:{
		// 重新翻譯666
		contactTool: '視訊工具',
		selectContactTool: '這是老師提供的視訊工具，請選擇：',
		
		
		
		appointmentCourse: '預約課程',
		teacher: '老師',
		coursePackage: '課堂包',
		remainingClasses: '剩除堂數',
		selectedClasses: '已選取',
		availableClasses: '尚可選取',
		nextStep: '下一步',
		cancel: '取消',
		confirm: '確認',
		reservationSuccess: '預約成功',
		appointmentClass:'預約堂數',
		classDate:'課程日期',
		time:'時間',
		selectContact:'請選擇聯係方式'
	},
	 teacherConfirms: {
			// 666重新翻译
			contactTool: '視訊工具',
			studentEntryTime: '學生進入課室時間:',
		 
		 
	        // 模板部分翻译
	        week: '星期',
	        year: '年',
	        month: '月',
	        day: '日',
	        utcTime: '(UTC+08:00)',
	        classId: '課時ID:',
	        language: '語言',
	        duration: '時長',
	        price: '價格',
	        languageCategory: '語言類別',
	        languageType: '語言類',
	        restTimeNote: '一些老師可能會在課程時間中包括5分鐘的休息時間。',
	        
	        avatar: '偶人會議ID',
	        password: '密碼',
	        teacherEntryTime: '老師進入課室時間:',
	        
	        notes: '筆記',
	        homework: '作業',
	        test: '測驗',
	        uploadHomework: '上傳作業',
	        uploadTest: '上傳測驗',
	        pendingTeacherConfirm: '待老師確認預約',
	        yourClassPending: '你的課時等待老師確認',
	        cancelReschedulePolicy: '如需取消或重新預約課時，請先閱讀我們的',
	        pendingConfirm: '待確認預約',
	        classPendingConfirm: '課堂等待確認',
	        pendingClass: '待上課',
	        classStartOnTime: '你的課時將於預約的時間開始',
	        classCompletedPendingConfirm: '完課待確認',
	        confirmWithin3Days: '請在課堂結束後的 3天內確認，否則系統將在{time}({timeZone})自動確認課堂',
	        reportClassNotCompleted: '如果你的課堂沒有像預期的那樣結束，你可以點擊“課堂未完成” 來報告。',
	        completed: '已完成',
	        rateTeacherWithin3Days: '請在確認課堂後3天內給予老師評價',
	        classCompletedCongrats: '恭喜，本節課堂已完成',
	        classNotCompleted: '課堂已處理',
	        waitingTeacherProcess: '等待老師處理，老師將{time}({timeZone}) 前處理。',
	        classNotCompletedResultConfirm: '課堂未完成處理結果確認',
	        processWithin48Hours: '請在48小時內{time} ({timeZone}) 前處理。',
	        teacherSolution: '老師處理方案：',
	        refundAmount: '退款金額：',
	        agree: '同意',
	        applyPlatformRuling: '申請平台裁決',
	        waitingPlatformRuling: '等待平台裁決',
	        pleaseWaitPlatform: '請等待平台處理',
	        confirmClass: '確認課堂',
	        cancelClass: '取消課堂',
	        enterClassroom: '進入教室',
	        interruptNote: '如遇中斷，請再按此按鈕進入教室',
	        accomplishClass: '確認課堂',
	        classNotAccomplished: '課堂未完成',
	        rateTeacher: '評價老師',
	        viewEvaluation: '查看評價',
	        // JS 部分翻译
	        confirmCancel: '確定要取消嗎？',
	        cancelClassText: '取消課堂',
	        confirmAction: '確定',
	        cancelAction: '取消',
	        operationSuccess: '操作成功',
	        confirmAppointment: '確定要確認預約嗎？',
	        confirmAppointmentText: '確認預約',
	        enterClassroomText: '進入教室',
	        confirmCompletion: '確定要確認課堂完成嗎？',
	        confirmCompletionText: '確認課堂完成',
	        confirmDelete: '確定要刪除嗎？',
	        deleteText: '刪除',
	        confirmAgree: '確定要同意嗎？',
	        agreeResultText: '同意處理結果',
	        confirmPlatformRuling: '確定要申請平台裁決嗎？',
	        platformRulingText: '申請平台裁決',
			policy:'《取消和重新預約政策》'
	},
	 addClass: {
		 // 666重
			type: '程度',
			courseName: '科目',
			discount: '折扣(%)',
			referencePrice:'參考價格',
			
			// 新
			referencePrice1:'1對1補習參考價錢',
			referencePrice2:'(每50分鐘計)',
			referencePrice3:'年級',
			referencePrice4:'大學生',
			referencePrice5:'大學畢業生',
			referencePrice6:'全職老師',
			referencePrice7:'註冊教師',
			referencePrice8:'初小(P1-4)',
			referencePrice9:'呈分試(P5-6)',
			referencePrice10:'初中(S1-3)',
			referencePrice11:'DSE (S4-6)',
			referencePrice12:'國際課程(IB、iGCSE、A-Level)',
			referencePrice13:'*以上價錢僅供參考，亦不代表本平台的建議定價，老師可自由定價。',
			
			
		 
	        addCourse: '添加課程',
	        pleaseSelect: '請選擇',
	        classNumber: '堂數',
	        teacherEarningsPerClass: '老師應得/每堂',
	        displayPricePerClass: '顯示價錢/毎堂',
	        noDiscount: '無',
	        referenceMarketValue: '正式堂價錢: 最少{currency}$80/堂  試堂價錢:為正式堂的1/3',
	        cancel: '取消',
	        save: '保存',
	        confirmCancel: '確定要取消嗎？',
	        saveSuccess: '保存成功',
			popular:'熱門'
	    },
	 classManage: {
		 // 666 重
			upgrade:'距離下次升級還有{hour}課時',
			viewCommissionRatio: '查看佣金比例',
		 
		 
	        currentLevel: '現時等級',
	        priceAdjustmentNotice: '價錢調整公示中',
	        setClassTypeAndPrice: '設置課堂種類和價錢',
	        trialClass: '試堂',
	        oneClass25Minutes: '1堂25分鐘課',
	        save: '保存',
	        addCourse: ' + 添加課程',
	        confirmDelete: '確定要刪除嗎？',
	        deleteCourse: '刪除該課程',
	        submitSuccess: '提交成功，請等待審核',
	        operationSuccess: '操作成功',
	        cancel: '取消',
			effectiveTime:'生效时間',
			revokeModifications:'撤銷修改',
			setPrice:'設定價格'
		},
	 myClassTeacher: {
	        myClassroom: '我的課堂',
	        waitingStudentConfirm: '待學生確認',
	        startingToday: '今日即將開始',
	        waitingMyConfirm: '待我確認的課堂',
	        futureClassroom: '未來的課堂',
	        completed: '已完成',
	        exception: '異常',
	        confirmCancel: '確定要取消嗎？',
	        submitSuccess: '提交成功',
	        operationSuccess: '操作成功',
			contactTools:'聯係工具',
			
	    },
	myStudents: {
		// 666 重新翻译
	        onCampusStudents: '在讀學生',
	        archivedStudents: '舊生記錄',
			remainingBalance: '剩餘堂數',
			
			// 新的
			grade:'年級',
			totalHalls:'總堂數',
			studentData:'學生資料',
			modal1:'學校類別',
			modal2:'就讀的課程',
			modal3:'想補的科目',
			modal4:'學習目標',
			modal5:'就讀的學校',
			modal6:'年級',
			modal7:'考卷語言(非語文科)',
			modal8:'授課語言要求',
			sendLesson:'發送課包給學生',
			coursePackage:'課包',
			scoreRange:'請輸入50-100分',
			
			
			
	        student: '學生',
	        learnedCourse: '所學課程',
	        prepaidBalance: '預付餘額',
	        woXueZhiReport: '窩學智報告',
	        communication: '通訊',
	        appointmentClass: '預約課堂',
	        learningReport: '學習報告',
	        pleaseFill: '請填寫',
	        operationSuccess: '操作成功',
	        confirm: '確認',
	        cancel: '取消',
			classHour:'課時'
	    },
	resolved: {
	        title: '已解決',
	        solutionInfo: '請選擇與學生商定後的解決方案，提交後由學生在48小時內進行確認',
	        selectSolution: '*請選擇調解方案',
	        pleaseSelect: '請選擇',
	        none: '無',
	        courseCompleted: '課程已完成',
	        returnOnce: '退回一次',
	        partialRefund: '部分退款',
	        fillRefundAmount: '*請填寫退款金額',
	        feeInfo: '該課的學費先扣退款金額，再扣佣金，剩餘部分打入老師錢包',
	        confirm: '確認',
	        cancel: '取消',
	        confirmResolve: '確定已經解決嗎？',
	        resolveText: '解決',
	        operationSuccess: '操作成功'
	    },
	 schedule: {
	        teachingTime: '授課時間',
	        availableTeachingTime: '可授課時間',
	        addTimeSlot: '+添加時間段',
	        generatedTeachingTime: '生成的可授課時間如下：',
	        effectiveDate: '生效日期',
	        always: '總是',
	        until: '直到',
	        save: '保存',
	        confirmDelete: '確定要刪除嗎？'
	    },
	statistics: {
			// 666 重新翻译
	        total: '統計',
			totalStudents: '學生總人數',
			
			// 新
			lastMonth:'上月',
			pastYear:'近一年',
			title2:'賣出課包總額',
			title3:'老師總收入',
			title4:'星級老師次數',
			title5:'就讀人數',
			title6:'完成堂數',
			title7:'推薦加盟人數',
			title8:'推薦獎賞',
			title9:'新收學生人數',
			title11:'每月平均堂數',
			title12:'正式轉化率',
			title13:'正式堂評分',
			title14:'老師檔案瀏覽量',
			title15:'試堂人數',
			title16:'試堂轉化率',
			title17:'試堂評分',
			filterType:'總收入（扣除佣金）',
			
			
			
	        netIncomeTotal: '淨收益總額',
	        unparticipatedTrials: '你沒有參加的審判',
	        tutoringHours: '輔導時數',
	        averageRating: '平均評分',
	        totalRatings: '評分總數',
	        
	        averageClassRating: '平均課時評分',
	        allCoursesStudentAvgRating: '你所有課程的學生平均評分',
	        hoursPerStudent: '每名學生的小時數',
	        calculationMethod: '它是通過你的輔導課時數除以學生總數來計算的。',
	        attendanceStatus: '你的缺勤情況',
	        annualPerformanceLast365Days: '最近365天的年度表現(最後更新日期為2025年2月7日)',
	        profileViews: '個人資料瀏覽量',
	        studentConversionRate: '對學生的轉化率',
	        effectiveClassHours: '有效上課時長',
	        hourlyRate: '小時費率',
	        newStudents: '新來的學生',
	        activeStudents: '活躍的學生',
	        classHoursPerActiveStudent: '每個活躍學生的課時',
	        trialClassRating: '試聽課評分',
	        allTime: '所有時間',
	        thisMonth: '本月',
	        thisWeek: '本周',
	        downloadIncomeReport: '下載收益報告'
	    },
	 teacherSet: {
			// 666重新翻
			teacherInfo: '老師個人資料',
			contactTools: '視訊工具',
			meetingLink: '會議連結',
			voov: 'VooV Meeting',
			
			// 新
			realName:'真實姓名',
			dateBirth:'出生日期',
			address:'住址',
			proofAddress:'上存住址證明副本',
			IDcard:'身份證/護照',
			number:'號碼',
			copyOfidentification:'上存身份證明文件副本(有個人資料和照片的頁面)',
			haveproblem:'如有上述資有何錯誤或更改，請立即',
			localTransfer:'本地轉賬',
			localTransferHint:'只接受本地(香港)的銀行戶口)',
			bankTransfer:'銀行轉賬',
			nameAll:'姓名',
			bankName:'銀行名稱',
			accountNumber:'戶口號碼',
			zhuanshukuai1:'轉數快號碼/電話號碼',
			crossTransfer:'跨境轉賬',
			emailAccount:'電郵賬號',
			fillCarefully:'* 基於保安理由，以上資料，設置後，將無法自行編輯，請小心填寫。',
			IConfirm:'我確認以上戶口屬本人所有，及清楚明白及同意',
			withdrawalArrangement:'提款安排和細則',
			wArrangement1:'提款流程',
			wArrangement2:'我們會在每月最後一天結算及處理所有申請',
			wArrangement3:'一般情況下，我們會在申請月份的下個月首10天或以內，將款項轉給你。 例如：你於6月30日提出申請，款項將於7月10日或之前轉賬',
			wArrangement4:'其他須知',
			wArrangement5:'以上期限均以香港時區為準',
			wArrangement6:'所有款項以港元 (HK$) 支付',
			wArrangement7:'款項只會發放至老師的個人戶口，不接受轉賬至他人（包括親屬）戶口或聯名戶口',
			wArrangement8:'銀行轉賬服務暫只支援本地（香港）銀行，如需跨境匯款，請使用 PayPal',
			wArrangement9:'如使用 PayPal 收款，可能涉及收款費用，詳情請向該公司查詢',
			contactTools1:'注意事項',
			contactTools2:'如使用 Zoom 免費版，每次會議限時 40 分鐘，不足以進行 50 分鐘的正式堂。請預先提醒學生課堂中會有時限，並在限時後重新進入課室。建議可考慮使用 VooV Meeting或選購 Zoom 專業版，以免影響學生的上課體驗',
			contactTools3:'會議室密碼將顯示給學生，請勿使用與你其他私人帳戶（如電郵、電子銀行等）相同的密碼',
			
			
			
			
		 
		 
	        teacherAccountSetting: '老師賬號設定',
	        cloaking: '隱身',
	        uncloaking: '未隱身',
	        setToCloaking: '設爲隱身',
	        cancelCloaking: '取消隱身',
	        
	        avatar: '頭像',
	        name: '名字',
	        surname: '姓氏',
	        speakLanguages: '會説語言（可多選）',
	        select: '請選擇',
	        level: '級別',
	        professorLevel: '教授級別',
	        specialEducationExperience: '特殊教育經驗',
	        educationBackground: '學歷',
	        certificate: '證書',
	        synopsis: '一句話簡介',
	        selfIntroduction: '自我介紹',
	        imageIntroduction: '圖片介紹',
	        video: '影片',
	        uploadVideo: '上傳影片',
	        inputYoutubeLink: '請翰入Paypal賬號',
			inputzhuanshukuai:'請翰入轉数快賬號',
	        confirm: '確認',
	        cancel: '取消',
	        save: '保存',
	        dataUnderReview: '資料密核中，請勿重新提交...',
	        paymentMethod: '收款方式',
	        paypal: 'Paypal',
	        zhuanshukuai: '轉數快',
	        zoom: 'Zoom',
	        personalMeetingNumber: '個人會議號碼(PMI)',
	        meetingRoomPassword: '會議室密碼',
	        submitSuccess: '提交成功'
	    },
	unresolved:{
		platformProcessing:'提交未解决申请后，由平台处理',
		unresolved:'未解决'
	},
	viewCommission: {
			// 666 重
			commissionRatio: '佣金比例',
			level: '老師級別',
	        hours: '纍積課時(小時)',
	        mtExtraction: '佣金率%',
	        
	        
	        classCalculationNote: '50分鐘堂，當1小時計算，試堂不計',
	        gotIt: '我知道了'
	    },
	 wallet: {
			// 666 重
			approximateAmountNote: '*此金額可能因匯率變動而有所差別，僅供參考，所有金額均以港幣HK$為準',
			maxWithdraw: '可用餘額 {amount}{currency}',
			// 新
			hint1:'扣除已申請提現的結餘',
			hint2:'總結餘(未扣提現申請)',
			hint3:'包括待審批和待發款的提現金額',
			ordercontent1:'全部交易詳情',
			ordercontent2:'收入詳情',
			ordercontent3:'提現情況',
			ordercontent4:'課堂訂單',
			ordercontent5:'本月',
			ordercontent6:'上月',
			ordercontent7:'近一年',
			ordercontent8:'所有時間',
			ordercontent9:'訂單編號',
			ordercontent10:'課包',
			ordercontent11:'類別',
			ordercontent12:'學生',
			ordercontent13:'課時ID',
			ordercontent14:'結餘',
			ordercontent15:'備註',
			ordercontent16:'申請時間',
			ordercontent17:'提款編號',
			ordercontent18:'提現方式',
			ordercontent19:'提現金額',
			ordercontent20:'狀況',
			ordercontent21:'操作時間',
			ordercontent22:'預計淨金額扣除佣金',
			ordercontent23:'訂單ID',
			ordercontent24:'堂數',
		 
		 
	        myWalletTeacher: '我的錢包（老師）',
	        withdraw: '提款',
	        availableBalance: '可用結餘',
	        totalBalance: '總結餘',
	        pendingBalance: '待批結餘',
	        
	        walletTransactionDetails: '錢包交易詳情',
	        withdrawalDetails: '提款詳情',
	        time: '時間',
	        item: '事項',
	        amount: '金額（{currency}）',
	        courseId: '課程ID',
	        status: '狀況',
	        cancelWithdrawal: '取消提款',
	        myWalletTutor: '我的錢包 (老師)',
	        transferToStudentWallet: '轉賬至學生錢包',
	        withdrawFromInternalAccount: '從內部賬戶提取款項',
	        transferMethod: '轉賬方式',
	        paypal: 'Paypal',
	        fps: '轉數快',
	        email: '電子郵件',
	        enter: '請輸入',
	        withdrawAmount: '提取金額',
	        
	        cancel: '取消',
	        withdrawProfit: '提取收益',
	        transferToStudent: '轉賬至學生錢包',
	        confirm: '確認',
	        operationSuccess: '操作成功',
	        confirmCancel: '確定要取消嗎？',
	    },
	 becomeTeacher: {
			// 666 新的
			miraTeacher:'成為ＭＩＲＡ老師',
			continueTeacher:'延續你的教學夢',
			applyNow:'立即申請',
			idealIncome:'可以理想收入',
			restriction:'學費會有限制',
			recommendedPlan:'推薦計劃',
			increaseIncome:'增加收入',
			details:'詳情',
			modalOne1:'佣金累退制，收入比例只升不降！',
			modalOne2:'我們的收取的佣金，是按老師累積的完成課時計算，課時越多，佣金比率越低！',
			modalOne3:'佣金詳情',
			modalOne4:'永不重置的升級系統',
			modalOne5:'佣金比率是按終身累積課時計算，無須擔心要每月「從頭再來」',
			modalOne6:'收入計算例子：',
			modalOne7:'若你定價$500/堂，達到老師級別MT10後：',
			modalOne8:'每天平均只需授課2堂(每堂50分鐘)',
			modalOne9:'月入可達$25,000！',
			modalOne10:'每堂實收約$417（83.50%），較新老師(MT1)多約19%！',
			modalTwo1:'自主定價，不設上限',
			modalTwo2:'老師可以根據自己的資歷（註冊教師、學歷、教學經驗等）和參考香港市場價格（如DSE每堂$450+、IB課程$600+），自由定價*，而定價不設上限。',
			modalTwo3:'競爭力優勢',
			modalTwo4:'老師教授熱門課程如DSE、IB、iGCSE、A-Level等等，需求極高，家長十分願意購買優質老師的課堂，你的資歷就是定價根基',
			modalTwo5:'*試堂是按老師正式堂定價的比例計算 ',
			modalThree1:'老師推薦計劃 - 裂變式增加課時，加速老師升級！',
			modalThree2:'推薦新老師成功加入，對方首3個月內的完成課時，100%叠加至你的累積課時計算，加快老師升級。',
			modalThree3:'計劃詳情',
			modalThree4:'爆發式增加收入',
			modalThree5:'如果你推薦1位老師（完成80小時課程），你將獲得80小時的額外時數，並晉升至MT4，佣金降至25.5%！',
			modalThree6:'若你推薦5位老師（每位完成80小時），你將累積400小時，直接升至MT7，佣金降至21%！考慮到你的課時和創始老師優惠，佣金可能會低於20%。',
			modalThree7:'永久佣金降低——推薦越多，賺得越多！',
			modalThree8:'現在加入，還可搶佔「創始老師」名額 ',
			modalThree9:'首10名老師：贈1050課時（直達MT9級別-18%佣金）！',
			modalThree10:'第11-110名老師：贈80課時（快速跳級至MT4）！',
			modalThree11:'無論你身在英國、加拿大或澳洲，只需網路與你的專業知識，即可重啟教學事業，賺取理想收入！',
			applicationProcess:'申請流程',
			applicationProcessOne1:'填寫申請表及遞交學歷證明',
			applicationProcessOne2:'只需 10 分鐘，填寫簡單申請表並上載學歷證明。',
			applicationProcessOne3:'合資格申請者將於 5 個工作天內收到面試通知。',
			applicationProcessTwo1:'面試',
			applicationProcessTwo2:'面試會以 Zoom 視像會議進行。',
			applicationProcessTwo3:'通過面試的老師將於 5 個工作天內獲通知。',
			applicationProcessThree1:'教學基本設置',
			applicationProcessThree2:'通過面試後，我們會為你開通老師帳戶。',
			applicationProcessThree3:'你只需設置教學檔案、通訊工具及收款方式，完成開教申請。',
			applicationProcessFour1:'開始教學',
			applicationProcessFour2:'完成設置後，我們會進行最後覆核。',
			applicationProcessFour3:'一切就緒後，你最快可於 5 個工作天內展開你的教學之旅！',
			teachingArchives:'教學檔案',
			workExperience:'工作經驗',
			teacherServiceTerms:'老師服務條款',
			Required:'必填',
			nameE: '名字(英文)',
			surnameE: '姓氏(英文)',
			sex:'性别',
			nationality:'國籍',
			residence:'居住地',
			phoneNumber:'電話號碼(可收Whatsapp)',
			recommendTeachers:'有否推薦老師?',
			contactEmail:'聯絡電郵',
			teachersNumber:'請輸入推薦老師的編號',
			startCreateProfile2:'請填寫以下教學資料',
			teachingSubjects:'教授科目(可多選)(最多10個)',
			yearRange:'年份',
			workingBody:'工作機構',
			position:'職位',
			listFour1:'上傳工作認明',
			listFour2:'文件規格',
			listFour3:'大小不能超過2MB',
			listFour4:'僅限pdf、bmp、jpg、png格式',
			listFour5:'添加經驗',
			listFive1:'請填寫自我介紹',
			listFive2:'簡歷標題 (一句話概括你想表達的教學特色和重點) ',
			listFive3:'請輸入5-30個字符，可使用表情符號。',
			listFive4:'(例子：前日校教師💡20年教學經驗👍、專攻DSE數學💯考試沖刺班)',
			listFive5:'請輸入50-1000個字符，可使用表情符號。',
			listSix1:'老師服務正式協議',
			listSix2:'綜合而言，我們想你清楚及明白，你是以自由工作者(Freelance Contractor)的身份在MiraStudent平台(由Mira Talker Limited擁有和經營)提供服務。作為MiraStudent的老師，你將代表自己為平台的使用者提供服務。',
			listSix3:'點選此框代表本人已清楚及明白上述協議，並同意協議的內容。',
			modalSuccess1:'提交申請成功！',
			modalSuccess2:'我們已收到你的申請，正在處理中，將會在7個工作天內回覆，請留意你的電郵(可能在垃圾郵件)，多謝你的耐心等侯。',
			modalSuccess3:'請記下你的申請編號 {num}，以便日後跟進，謝謝！',
			modalSuccess4:'知道了',
			educationBackground1:'大學/教育機構',
			educationBackground2:'學位/文憑名稱',
			educationBackground3:'上傳證書副本',
			educationBackground4:'請填寫以下學歷資料',
			educationBackground5:'添加學歷',
			educationBackground6:'專業資格',
			educationBackground7:'專業教師資格',
			educationBackground8:'如你是註冊教師(即曾經在教育局註冊)，並向我們提交有關證明副本，我們將在你的個人簡介顯示專業教師的徽章，以便家長和學生識別你的專業資格',
			educationBackground9:'我是註冊教師',
			educationBackground10:'否',
			educationBackground11:'頒發機構',
			educationBackground12:'證書名稱',
			educationBackground13:'上傳教師證副本',
			educationBackground14:'其他專業資格',
			educationBackground15:'添加證書',
			educationBackground16:'公開試成績',
			educationBackground17:'考試名稱',
			educationBackground18:'成績',
			educationBackground19:'上傳成績單副本',
			educationBackground20:'添加成績',
			
			
			
			// 重新翻译
			fillPersonalInfo: '個人資料',
			fillIntroduction: '個人介紹',
			startCreateProfile: '請填寫以下個人資料，而有關資料將會保密：',
			name: '名字(中文)',
			surname: '姓氏(中文)',
			professorLevel: '教授級別(可多選)',
			
		 
		 
	        becomeTeacher: '成為老師',
	        uploadPhoto: '2 上傳照片',
	        uploadCertificate: '3 上傳證書',
	        fillEducation: '4 填寫學歷',
	        uploadVideo: '6 上傳影片',
	        fillTeachingTime: '7 填寫授課時間',
	        fillTuition: '8 填寫學費',
	        pleaseFill: '請填寫',
	        speakLanguages: '會說語言(可多選)',
	        level: '級別',
	        specialEducationExperience: '特殊教育經驗',
	        nextStep: '下一步',
	        photo: '照片',
	        previousStep: '上一步',
	        certificate: '證書',
	        education: '學歷',
	        synopsis: '一句話簡介',
	        selfIntroduction: '自我介紹',
	        imageIntroduction: '圖片介紹',
	        inputYoutubeLink: '請輸入Youtube連結',
	        confirm: '確認',
	        teachingTime: '授課時間',
	        availableTeachingTime: '可授課時間',
	        addTimeSlot: '+添加時間段',
	        generatedTeachingTime: '生成的可授課時間如下：',
	        effectiveDate: '生效日期',
	        always: '總是',
	        until: '直到',
	        setClassTypeAndPrice: '設置課堂種類和價錢',
	        viewCommissionRatio: '查看分成比例',
	        trialClass: '試堂',
	        one25MinClass: '1堂25分鐘課',
	        formalClass: '正式堂',
	        addCourse: '+ 添加課程',
	        submit: '提交',
	        submitSuccess: '提交成功，請等待審核',
			hint1: '請輸入名字',
			hint2: '請輸入姓氏',
			hint3: '請選擇會說的語言與級別',
			hint4: '請選擇教授級別',
			hint5: '請選擇特殊教育經驗',

	    },
	 teacherIndex: {
			// 666新加
			classroomReport1:'本課重點',
			classroomReport2:'課題',
			classroomReport3:'學習重點',
			classroomReport4:'學生表現',
			classroomReport5:'專注力',
			classroomReport6:'掌握度',
			classroomReport7:'參與度',
			classroomReport8:'進步幅度',
			classroomReport9:'作業/測驗',
			classroomReport10:'總評 ',
			classroomReport11:'老師留言',
			classroomReport12:'課堂亮點',
			classroomReport13:'學習建議',
			classroomReport14:'下堂預告',
			classroomReport15:'提交及確認完成課堂',
			textMessage:'短訊',
			sellingHall:'卖堂',
			progressReport1:'應試表現',
			progressReport2:'時間管理和規劃',
			progressReport3:'審題與理解能力',
			progressReport4:'答題速度與效率',
			progressReport5:'準確度與細心程度',
			progressReport6:'解題策略與技巧',
			progressReport7:'壓力管理與心熊調整',
			progressReport8:'檢查與復查策略',
			progressReport9:'短語',
			progressReport10:'學習建議',
			progressReport11:'下個目標',
			progressReport12:'建議課包',
			
			
			
			
	        teacherCenter: '老師中心',
	        myClass: '我的課堂',
	        myStudents: '我的學生',
	        classManagement: '課堂管理',
	        schedule: '日程',
	        statistics: '統計',
	        wallet: '錢包',
	        settings: '設定',
	    },
	 statusConfirms: {
			// 666重新翻譯
			contactToolSection: '視訊工具',
			studentEntryTime: '學生進入課室時間:',
		 
		 
	        appointmentCourse: '預約課程',
	        teacher: '老師',
	        coursePackage: '課堂包',
	        remainingClasses: '剩餘堂數',
	        selectContactTool: '這些是老師使用的聯絡工具，請選擇聯絡工具',
	        contactTool: '聯絡工具',
	        nextStep: '下一步',
	        confirmReservation: '確認預約',
	        cancel: '取消',
	        confirm: '確認',
	        selectContactWay: '請選擇聯繫方式',
	        reservationSuccess: '預約成功',
	        week: '星期',
	        hoursFormat: '{start} / {end}',
	        classId: '課時ID:',
	        courseName: '課堂名稱',
	        language: '語言',
	        duration: '時長',
	        price: '價格',
	        languageCategory: '語言類別',
	        languageType: '語言類',
	        breakNote: '一些老師可能會在課堂時間中包括5分鐘的休息時間。',
	        meetingId: '偶人會議ID',
	        password: '密碼',
	        teacherEntryTime: '老師進入課室時間:',
	        notes: '筆記',
	        uploadNotes: '上傳筆記',
	        homework: '作業',
	        uploadHomework: '上傳作業',
	        test: '測驗',
	        uploadTest: '上傳測驗',
			waitingStudentConfirmClass:'你的課時等待學生確認',
	        waitingStudentConfirm: '待學生確認預約',
	        waitingConfirm: '待確認預約',
	        waitingClass: '待上課',
	        classCompletedConfirm: '完課待確認',
	        classCompleted: '已完成',
	        classNotCompleted: '課堂已處理',
			studentConfirm:'學生將在課堂結束後的 3 天內確認，否則系統將在{finish_time} ({timeZone}) 自動確認課堂。',
	        studentMarkedNotCompleted: '學生標記課堂未完成，請在 {time} ({timeZone}) 前處理。以下是學生填寫內容',
	        notCompletedReason: '因{reason}原因課堂未完成，希望可以{expectedResult}',
	        content: '{content}',
	        resolved: '已解決',
	        unresolved: '未解決',
	        waitingPlatformDecision: '等待平台裁決',
	        confirmCourse: '確認課堂',
	        cancelClass: '取消課堂',
	        enterClassroom: '進入教室',
	        reenterNote: '如遇中斷，請再按此按鈕進入教室',
	        accomplishCourse: '確認課堂',
	        courseNotCompleted: '課堂未完成',
	        confirmCancel: '確定要取消嗎？',
	        operationSuccess: '操作成功',
	        cancelAndReschedulePolicy: '《取消和重新預約政策》',
			teacherhandlingplan:'老師處理方案',
			refundAmount:'退款金額',
			processWithin48Hours: '等待學生確認，學生將在48小時內 {time}({timeZone})前處理。',
			result1: '課堂已完成',
			result2: '退回一次',
			result3: '部分退款'
	    },
	classTime: {
	        selectCourseStartTime: '請選擇課程的開始時間({timeZone})',
	        obtained: '已獲取',
	        noCourse: '暫無課程',
	    },
	 introductionTeacher: {
	        introduceTeacher: '介紹老師',
	        recommendTeacherTip: '可填寫被推薦的老師用戶名，平臺審核通過后，首3個月内被推薦的老師獲得的時數將會同時加到你的纍計時數中',
	        recommendTeacher: '推薦老師',
	        inputTeacherEmail: '請輸入老師的郵箱賬號',
	        confirm: '確定',
	        recommendedTeachers: '已推薦老師',
	        pendingReview: '待審核',
	        close: '關閉',
	        operationSuccess: '操作成功'
	    },
	 recharge: {
			// 重新翻译
			rechargeAmount: '儲值金額',
			recharge: '儲值',
		 
		 
	        
	        inputPrompt: '請輸入',
	        thirdPartyFee: '第3方支付手續費(不能退款) + 5%',
	        totalPrice: '總價',
	        cancel: '取消',
	        submit: '提交',
	        confirmRecharge: '確定要進行充值嗎？',
	        rechargeBalance: '充值餘額',
	        rechargeSuccess: '充值成功'
	    }
}